
import mqtt from 'mqtt'
import React, { createContext, useEffect, useState } from 'react'
import apiConfig from '../utils/allApi'

export const mqttContext = createContext(null)
const MqttConnection = ({children}) => {
  const [client, setClient] = useState(null)
  const [isConnected, setIsConnected] = useState(false);
  const mqtt_url = apiConfig.api_mqttUrl;
  const username = apiConfig.api_mqttusername;
  const password = apiConfig.api_mqttpassword;
  useEffect(() => {
    const host = mqtt_url;
    const options = {
      clientId : "clientID-QC-Web-" + parseInt(Math.random() * 100),
      username : username,
      password :password,
      clean : true
    }

    const mqttClient = mqtt.connect(mqtt_url,options);
    setClient(mqttClient)
    mqttClient.on('connect', () => {
      setIsConnected(true)
    });

    mqttClient.on('error', (err) => {
    });
    
    return () => {
      mqttClient.end();
    }
  }, []);
  
  return (
    <mqttContext.Provider value={{client, isConnected}}>
     {children}
    </mqttContext.Provider>
  )
}

export default MqttConnection